import React, { useEffect, useState } from "react";
import { Sparkles, Loader2, Check } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";
import { Button } from "@/components/ui/button";

const DESCRIPTIONS = {
  claude: "Analyses détaillées et nuancées (Anthropic). Modèle par défaut.",
  gemini: "Analyses rapides et synthétiques (Google Gemini 3.1 Pro).",
};

export const AiModelSettings = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [model, setModel] = useState("claude");
  const [options, setOptions] = useState([]);

  const load = async () => {
    try {
      const { data } = await api.get("/admin/settings/ai-model");
      setModel(data.model);
      setOptions(data.options || []);
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const save = async (value) => {
    setSaving(true);
    try {
      const { data } = await api.put("/admin/settings/ai-model", { model: value });
      setModel(data.model);
      toast.success(`Modèle IA défini : ${data.label}`);
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-2xl rounded-xl border border-slate-200 bg-white p-6" data-testid="ai-model-settings">
      <div className="flex items-center gap-2">
        <Sparkles className="h-5 w-5 text-ciel" />
        <h3 className="font-display text-base font-semibold text-navy">Modèle d'intelligence artificielle</h3>
      </div>
      <p className="mt-2 text-sm text-slate-500">
        Ce choix s'applique à <strong>toutes les analyses IA</strong> de la plateforme : licences, management
        stratégique, soins/PMSI, ambulances, satisfaction et visioconférence.
      </p>

      {loading ? (
        <div className="mt-6 flex items-center gap-2 text-sm text-slate-400">
          <Loader2 className="h-4 w-4 animate-spin" /> Chargement…
        </div>
      ) : (
        <div className="mt-6 grid gap-3 sm:grid-cols-2">
          {options.map((opt) => {
            const active = model === opt.value;
            return (
              <button
                key={opt.value}
                type="button"
                disabled={saving}
                onClick={() => !active && save(opt.value)}
                data-testid={`ai-model-option-${opt.value}`}
                className={`relative rounded-lg border p-4 text-left transition-colors ${
                  active ? "border-ciel bg-ciel/5 ring-1 ring-ciel" : "border-slate-200 hover:border-slate-300"
                } ${saving ? "opacity-60" : ""}`}
              >
                {active && (
                  <span className="absolute right-3 top-3 flex h-5 w-5 items-center justify-center rounded-full bg-ciel text-white">
                    <Check className="h-3 w-3" />
                  </span>
                )}
                <div className="font-semibold text-navy">{opt.label}</div>
                <p className="mt-1 text-xs text-slate-500">{DESCRIPTIONS[opt.value] || ""}</p>
                {active && <div className="mt-2 text-[11px] font-semibold uppercase tracking-wide text-ciel">Actif</div>}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
